import { useTranslation } from "react-i18next";

import { useCheckIsEmerson } from "@shared/hooks/useCheckIsEmerson/useCheckIsEmerson";
import { l } from "@shared/locales/i18n";

const EmersonTitle = () => {
  const { t } = useTranslation();
  const isEmerson = useCheckIsEmerson();

  if (isEmerson) {
    return <title>{t(l.sharedCommon.platforms.EmersonEcologics)}</title>;
  }

  return null;
};

export { EmersonTitle };
